/**
 * The browser holds the token of a suspended or frozen account. The API
 * refuses the signup calls for it, and signing in to that account is the
 * way forward.
 */

import { t } from '../i18n.js';

// The values of ForbiddenException::CODE_TOKEN_SCOPE_INSUFFICIENT and its `account_status`.
const TOKEN_SCOPE_INSUFFICIENT = 'token_scope_insufficient';
const REFUSED_ACCOUNT_MESSAGES = {
    suspended: 'auth.signup_error_browser_account_suspended',
    frozen: 'auth.signup_error_browser_account_frozen',
};

/**
 * @param {?{code: ?string, accountStatus: ?string}} error - an ApiClient error
 * @returns {?{msg: string, offersSignIn: boolean}} the wizard's general error, or null for any other error
 */
export function refusedAccountError(error) {
    const status = error?.accountStatus;
    const known = Object.prototype.hasOwnProperty.call(REFUSED_ACCOUNT_MESSAGES, status);
    if (error?.code !== TOKEN_SCOPE_INSUFFICIENT || !known) {
        return null;
    }

    return { msg: t(REFUSED_ACCOUNT_MESSAGES[status]), offersSignIn: true };
}
